import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var GetAwbDetailsService = /** @class */ (function () {
    function GetAwbDetailsService(httpObj) {
        this.httpObj = httpObj;
    }
    GetAwbDetailsService.prototype.getAwbDetails = function (uniqueIdForAwb, oauthToken) {
        //let requestURL: string;
        var requestUrl = environment.baseUrl + environment.docUploadContext + environment.GET_AWB_DETAILS_API_URL + uniqueIdForAwb;
        //requestURL = requestUrl + uniqueIdForAwb;
        return this.httpObj.get(requestUrl, this.setOptions(oauthToken));
    };
    GetAwbDetailsService.prototype.getDocument = function (oauthToken, awb, docType) {
        var requestUrl = environment.baseUrl + environment.docUploadContext + environment.GET_DOCUMENT + "/" + awb + "/" + docType;
        // let requestURL: string;
        // requestURL = requestUrl + "/" + awb + "/" + docType;
        return this.httpObj.get(requestUrl, this.setOptions(oauthToken));
    };
    //country config
    GetAwbDetailsService.prototype.getCountryBasedReasonDetails = function (countryCode, oauthToken) {
        //let requestURL: string;
        var requestURL = environment.baseUrl + environment.docUploadContext + environment.GET_CTRY_BASED_REASON_CODE + countryCode;
        return this.httpObj.get(requestURL, this.setOptions(oauthToken));
    };
    //country config
    GetAwbDetailsService.prototype.setOptions = function (oauthToken) {
        var oauthHeader = new HttpHeaders({
            'apikey': oauthToken
        });
        var options = { headers: oauthHeader };
        return options;
    };
    GetAwbDetailsService.ngInjectableDef = i0.defineInjectable({ factory: function GetAwbDetailsService_Factory() { return new GetAwbDetailsService(i0.inject(i1.HttpClient)); }, token: GetAwbDetailsService, providedIn: "root" });
    return GetAwbDetailsService;
}());
export { GetAwbDetailsService };
